<app-loader
	[enableCircle]="true"
	[isActive]="isLoading.value$ | async"
	[isAfterViewInit]="false"
></app-loader>
<nav
	[disableRipple]="true"
	class="mat-tab-nav-with-ink flex flex-row -4 --page-nav my-2"
	mat-tab-nav
	mat-tab-nav-bar
>
	@if (returnToCreateDialog$.value) {
	<div class="ml-4">
		<button
			(click)="returnToCreateDialog()"
			mat-stroked-button
			tabindex="-1"
		>
			<mat-icon>keyboard_return</mat-icon>
		</button>
	</div>
	}
	<div class="ml-auto mr-4">
		<button
			(click)="handleClose()"
			mat-icon-button
			tabindex="-1"
		>
			<mat-icon>close</mat-icon>
		</button>
	</div>
</nav>
<mat-dialog-content
	cdkTrapFocus
	class="!overflow-y-auto !max-h-[calc(100vh-200px)]"
>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.absenceGroup"
		*ngIf="this.absenceGroup as grp"
		class="multiAbsence-item mb-8 flex flex-col space-y-4"
	>
		<div class="flex flex-row gap-2">
			<div class="flex flex-auto flex-col items-stretch justify-start gap-2 lg:wflex-[1_0_440px]">
				<ng-container *ngIf="workspace$canManageOthers.value$ | async">
					<ng-container *ngIf="employeeFilter.value$ | async as selectedEmployees">
						<div
							[satPopoverAnchor]="employeeFilterPopover"
							class="mt-4"
						>
							<button
								(click)="employeeFilterPopover.toggle()"
								[active]="selectedEmployees.length > 0"
								[class.employee-filter-empty]="
									selectedEmployees.length === 0 && !(employeeFilterPopoverOpen.value$ | async)
								"
								[count]="selectedEmployees.length"
								class="w-full"
								icon="supervisor_account"
								labelKey="reports.filter-bar.users"
								tgFilterTrigger
								type="button"
							></button>
						</div>
					</ng-container>
				</ng-container>
				<div class="flex flex-row items-center gap-2 mt-1">
					<ng-container *ngIf="range.value$ | async as currentRange">
						<div class="hidden">
							<app-time-range-picker
								(rangeChange)="setRange($event)"
								[allowGeneralize]="false"
								[employee]="(employeeFilter.value$ | async) ?? []"
								[range]="currentRange"
								#absenceRangePicker
							></app-time-range-picker>
						</div>
						<div
							#rangeTriggerAnchor
							class="inline-flex"
						>
							<button
								(click)="absenceRangePicker.openRangePicker(rangeTriggerAnchor)"
								[matTooltip]="'utils.pickTimeRange' | translate"
								class="justify-center sm:items-start sm:justify-start"
								mat-button
								type="button"
							>
								<div class="flex flex-row items-center justify-start gap-1">
									<mat-icon>calendar_month</mat-icon>
									<ng-container
										*ngIf="(absenceRangePicker.range$SameDay | async); else absenceRangeYearOrDefault"
									>
										{{ currentRange.from | formatDate: 'PP' }}
									</ng-container>
									<ng-template #absenceRangeYearOrDefault>
										<ng-container
											*ngIf="(absenceRangePicker.range$SameYear | async); else absenceRangeDefault"
										>
											<span>{{ currentRange.from | formatDate: 'do LLL' }}</span>
											<span>-</span>
											<span>{{ currentRange.to | formatDate: 'do LLL' }}</span>
										</ng-container>
										<ng-template #absenceRangeDefault>
											<ng-container
												*ngIf="currentRange.from && currentRange.to; else absenceNoRange"
											>
												<span>{{ currentRange.from | formatDate: 'do LLL' }}</span>
												<span>-</span>
												<span>{{ currentRange.to | formatDate: 'do LLL' }}</span>
											</ng-container>
											<ng-template #absenceNoRange>{{
												'utils.pickTimeRange' | translate
											}}</ng-template>
										</ng-template>
									</ng-template>
								</div>
							</button>
						</div>
					</ng-container>
					<mat-form-field
						appearance="standard"
						class="ml-auto -mb-2"
					>
						<mat-select
							[placeholder]="'comego.types.leave_type' | translate"
							#initialTypeSelect
							formControlName="initialType"
						>
							@if (!absenceSubcategories?.length) {<mat-option value="absence">{{
								'comego.types.absence' | translate
							}}</mat-option
							>} @else {
							<mat-optgroup [label]="'comego.types.absence' | translate">
								<mat-option
									[style.display]="isAbsenceEnabledForSelection(subcategory) ? '' : 'none'"
									[value]="subcategory.id"
									*ngFor="let subcategory of absenceSubcategories"
								>
									{{ subcategory | absenceTranslate }}
								</mat-option>
							</mat-optgroup>
							}
						</mat-select>
						<mat-error *ngIf="absenceGroup.get('initialType')?.hasError('required')">
							{{ 'errors.required' | translate: ({ field: 'comego.types.leave_type' } | translateArgs) }}
						</mat-error>
					</mat-form-field>
				</div>
			</div>
		</div>
		<div class="flex flex-col space-y-3  max-h-[700px] flex-col space-y-4 overflow-y-auto">
			<ng-container *ngIf="range.value.from && employeeFilter.value.length">
				<mat-accordion class="m-1">
					@for (employee of absenceGroup.get('employees').controls; track employee.get('employee').value.id;
					let i = $index) {
					<mat-expansion-panel
						[expanded]="absenceGroup.get('employees').controls.length === 1 && userHasAnyConflict(employee)"
						#expansionPanel
						class="mat-elevation-z0 rounded-lg mb-2 absence-panel"
					>
						<mat-expansion-panel-header
							collapsedHeight="56px"
							expandedHeight="56px"
						>
							<mat-panel-title class="absence-panel-title">
								<div class="absence-panel-title__employee">
									<app-user-avatar
										[userId]="employee.get('employee').value.id"
										class="rounded-full shrink-0"
										size="32px"
									></app-user-avatar>
									<span
										[matTooltip]="employee.get('employee').value.name"
										class="min-w-0 truncate"
										>{{
											employee.get('employee').value.name | truncate: 25
										}}</span
									>
								</div>
								<div class="absence-panel-title__duration">
									@if( { summed: employee.get('summedDuration').value, target:
									employee.get('targetDuration').value, diff:
									getEmployeeDurationDifference(employee),}; as duration) {
									<div class="flex items-center gap-1.5 whitespace-nowrap">
										<span>{{ duration.summed | parseMsAsDuration: false : true }}</span>
										<span>/</span>
										<span>{{ duration.target | parseMsAsDuration: false : true }}</span>
										@if (userHasAnyConflict(employee)) { @if(!expansionPanel.expanded) {
										<mat-icon
											[matTooltip]="'errors.times.comego.absecenceOverlap' | translate"
											class="shrink-0 ml-3"
											color="warn"
											>warning</mat-icon
										>
										<button
											(click)="$event.stopPropagation(); resolveAbsenceConflict(employee)"
											[matTooltip]="'comego.resolveAbsenceConflict' | translate"
											class="shrink-0 opacity-40 hover:opacity-100 ml-3"
											mat-icon-button
											type="button"
										>
											<mat-icon>cancel</mat-icon>
										</button>
										} } @else if (duration.diff === 0 ) {
										<mat-icon class="shrink-0">check</mat-icon>
										} @else if(absenceGroup.get('initialType').value) {
										<mat-icon
											class="shrink-0"
											color="accent"
											>warning</mat-icon
										>
										<span>
											{{ duration.diff > 0 ? '+' : '-' }}
											{{
												(duration.diff < 0 ? -duration.diff : duration.diff) | parseMsAsDuration: false : false
											}}
											h
										</span>
										}
									</div>
									}
								</div>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div *ngFor="let absence of employee.get('absences').controls; let j = index">
							<div class="absence-row flex flex-row items-center gap-3 -mr-1">
								<div class="pr-1 op-70 whitespace-nowrap w-[35px]">
									{{ absence.get('date').value | date: 'EEE' }}
								</div>
								<div class="op-70 whitespace-nowrap">
									{{ absence.get('date').value | date: 'dd.MM.yyyy' }}
								</div>
								<mat-form-field
									[floatLabel]="'never'"
									appearance="standard"
									class="type-select-item -mb-[8px] min-w-0 w-[200px]"
								>
									<mat-select
										[formControl]="absence.get('type')"
										[placeholder]="'comego.types.leave_type' | translate"
									>
										@if (!absenceSubcategories?.length) {<mat-option value="absence">{{
											'comego.types.absence' | translate
										}}</mat-option
										>} @else {
										<mat-optgroup [label]="'comego.types.absence' | translate">
											<mat-option
												[style.display]="absencesForUser(subcategory, employee) ? '' : 'none'"
												[value]="subcategory"
												*ngFor="let subcategory of absenceSubcategories"
											>
												{{ subcategory | absenceTranslate }}
											</mat-option>
										</mat-optgroup>
										}
									</mat-select>
								</mat-form-field>

								<div
									[ngClass]="[ (isAMPM$ | async) ? 'w-[65px] min-w-[65px]' : 'w-[40px] min-w-[40px]']"
									class="min-w-0 -mb-[8px]"
								>
									<app-time-input
										[displayFormat]="false"
										[formControl]="absence.get('start')"
										[inputPlaceholder]="'timer.time.start' | translate"
										[maxlength]="5"
										#startInpRef="nativeElement"
										#tStartFormField
										elementRef
										matInput
									>
										<ng-template
											let-control="control"
											let-inputPlaceholder="inputPlaceholder"
											timeInputControl
										>
											<mat-form-field
												appearance="standard"
												class="group"
												fxFill
											>
												<mat-label
													[ngClass]="{'opacity-0': j !== 0}"
													class="xs:inline xs:transition-opacity"
													>{{
														inputPlaceholder
													}}</mat-label
												>
												<input
													[formControl]="control"
													[placeholder]="inputPlaceholder"
													matInput
													type="text"
												>
											</mat-form-field>
										</ng-template>
									</app-time-input>
								</div>
								<span class="tg-seperator shrink-0 text-center font-bold w-[10px]"> - </span>
								<div
									[ngClass]="[ (isAMPM$ | async) ? 'w-[65px] min-w-[65px]' : 'w-[40px] min-w-[40px]']"
									class="min-w-0 mt-2"
								>
									<app-time-input
										[displayFormat]="false"
										[formControl]="absence.get('end')"
										[inputPlaceholder]="'timer.time.end' | translate"
										[maxlength]="5"
										elementRef
										matInput
									>
										<ng-template
											let-control="control"
											let-inputPlaceholder="inputPlaceholder"
											timeInputControl
										>
											<mat-form-field
												appearance="standard"
												class="group"
												fxFill
											>
												<mat-label
													[ngClass]="{'opacity-0': j !== 0}"
													class="xs:inline xs:transition-opacity"
													>{{
														inputPlaceholder
													}}</mat-label
												>
												<input
													[formControl]="control"
													[placeholder]="inputPlaceholder"
													matInput
													type="text"
												>
												<mat-hint class="pl-1.5"> {{ absence.get('hours').value }} </mat-hint>
											</mat-form-field>
										</ng-template>
									</app-time-input>
								</div>
								@if (hasConflict(employee, absence)) {
								<div class="flex items-center justify-center w-[40px]">
									<mat-icon
										[matTooltip]="'errors.times.comego.absecenceOverlap' | translate"
										color="warn"
										>warning</mat-icon
									>
								</div>
								} @else {
								<div class="w-[40px]"></div>
								}
								<div
									*ngIf="workspace$canManageOthers.value$ | async"
									class="flex shrink-0 items-center justify-self-center opacity-40 group-hover:opacity-100 ml-auto"
								>
									<button
										(click)="disableAbsence(i, j)"
										[matTooltip]="'utils.remove' | translate"
										class="leading-none"
										mat-icon-button
										type="button"
									>
										<mat-icon>cancel</mat-icon>
									</button>
								</div>
							</div>
						</div>
						@if (absenceWithSupervisors.value$ | async) {
						<ng-container>
							<div class="absolute inset-x-0 bottom-0 mx-3 mb-14">
								<div class="alert alert-danger alert-tight rounded py-2">
									{{ 'errors.blockAbsence' | translate }}
								</div>
							</div>
						</ng-container>
						}
					</mat-expansion-panel>
					}
				</mat-accordion>
			</ng-container>
		</div>
	</form>
</mat-dialog-content>
<mat-dialog-actions class="mat-action-filled">
	<button
		(click)="submit()"
		[disabled]="!canSubmitAbsence()"
		class="mat-action-filled"
		color="primary"
		mat-flat-button
		type="button"
	>
		{{ 'comego.submitAbsence' | translate }}
	</button>
</mat-dialog-actions>
<tg-employee-filter-popover
	(itemsClose)="employeeFilter.next($event)"
	#employeeFilterPopover
></tg-employee-filter-popover>
